import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "../route/index.js";
import auth from "@/api/auth";

import packageJson from "../../package.json";

import users from "./users.module";
import js_report from "./js_report.module";
import fleet from "./fleet.module";
import roles from "./roles.module";
import notifications from "./notifications.module";
import activityTypeRoles from "./activityTypeRoles.module";
import permissions from "./permissions.module";
import customers from "./customers.module";
import settings from "./settings.module";
import orders from "./orders.module";
import report from "./report.module";
import company from "./company.module";
import auditlogs from "./auditlogs.module";
import quickbook from "./quickbook.module";

import itemType from "./itemType.module";
import orderType from "./orderType.module";

import assets from "./assets.module";
import locations from "./locations.module";

import masterItem from "./masterItem.module";
import orderCategory from "./orderCategory.module";
import order_report from "./order_report.module"
import orderTemplate from "./orderTemplate.module";
import s3files from "./s3files.module";
import customerPortal from "./customerPortal.module.js";

import requestCategory from "./requestCategory.module";
import interactionType from "./interactionType.module";
import customerAgents from "./customerAgents.module";
import progressStatus from "./progressStatus.module";
import crmOpportunityTypes from "./crmOpportunityTypes.module";
import checkoffTemplates from "./checkoffTemplates.module";
import checkoffTypes from "./checkoffTypes.module";
import additionalField from "./additionalField.module";
import additionalFieldNew from "./additionalFieldNew.module";
import additionalFieldNewMapping from "./additionalFieldNewMapping.module";
import customerSegments from "./customerSegments.module";
import lifecycleStage from "./lifecycleStage.module";
import customerGroups from "./customerGroups.module";

import transactionType from "./transactionType.module";
import orderRentalAssetStore from "./orderRentalAssetStore.module";
import orderItemStore from "./orderItemStore.module";

import orderAttachmentsStore from "./orderAttachmentsStore.module";
import assetAttachmentsStore from "./assetAttachmentsStore.module";
import customerAttachmentsStore from "./customerAttachmentsStore.module";
import companyAttachmentsStore from "./companyAttachmentsStore.module";
import orderMessagesStore from "./orderMessagesStore.module";
import siteAdmin from "./siteAdmin.module";
import analytics from "./analytics.module";
import synchronizer from "./synchronizer.module.js";

import payments from "./payments.module.js";
import paymentAttachmentsStore from "./paymentAttachmentsStore.module.js";
import masterBank from "./masterBank.module.js";
import asset_rental from "./asset_rental.module.js";
import reportTemplates from "./reportTemplates.module.js";
import assetScheduleStore from "./assetScheduleStore.module.js";
import emailSchedules from "./emailSchedules.module.js";
import billPaymentEmailSender from "./billPaymentEmailSender.module.js";
import billPaymentEmailSubjectLine from "./billPaymentEmailSubjectLine.module.js";
import rpaTask from "./rpaTask.module.js";
import rpaTemplate from "./rpaTemplate.module.js"
import billPaymentTo from "./billPaymentTo.module.js";


import health from "./health.module";
import document_type from "./document_type.module.js";
import master_document from "./master_document.module.js";
import masterdocAttachmentsStore from './masterdocAttachmentsStore.module.js';
import acitivityTypeDocStore from './acitivityTypeDocStore.module.js';
import item_type_group from './item_type_group.module.js';
import masterItemAttachmentsStore from './masterItemAttachmentsStore.module.js';
import languages from "./languages.module.js";
import holiday from './holiday.module.js';
import payment_type from "./payment_type.module.js";
import payment_purpose from "./payment_purpose.module.js";
import user_roster from "./user_roster.module.js";
import customer_document from "./customer_document.module.js";
import targets from "./targets.module.js";
import language from "./language.module.js";
import orderCategoryAttachmentsStore from "./orderCategoryAttachmentsStore.module.js";
import orderTypeAttachmentsStore from './orderTypeAttachmentsStore.module.js';
import orderItemTypeAttachmentsStore from './orderItemTypeAttachmentsStore.module.js';
import masterItemImageStore from './masterItemImageStore.module.js';
import products from "./products.module.js";
import services from "./services.module.js";
import rentals from "./rentals.module.js";
import requestAttachmentsStore from "./requestAttachmentsStore.module.js";
import assetTypeAttachmentsStore from "./assetTypeAttachmentsStore.module.js";
import assetsImageStore from './assetsImageStore.module.js';
import { errorHandler } from "../exports/error_management.js";
import aiRecon from './aiRecon.module';
// import { last } from "lodash";
Vue.use(Vuex);
const SECRET_KEY =
  "eyJhbGciOiJIUzI1NiJ9.eyJSb2xlIjoiQWRtaW4iLCJJc3N1ZXIiOiJJc3N1ZXIiLCJVc2VybmFtZSI6IkphdmFJblVzZSIsImV4cCI6MTcwMzE1NDgxMywiaWF0IjoxNzAzMTU0ODEzfQ.u80RU8sfK3TPOj2ggICN0Qgh5jNvc6H97jMlwzUG484";
export default new Vuex.Store({
  modules: {
    users,
    js_report,
    siteAdmin,
    fleet,
    notifications,
    roles,
    activityTypeRoles,
    permissions,
    customers,
    settings,
    orders,
    additionalField,
    additionalFieldNew,
    additionalFieldNewMapping,
    report,
    auditlogs,
    company,
    orderType,
    transactionType,
    customerAgents,
    itemType,
    assets,
    locations,
    masterItem,
    orderCategory,
    order_report,
    orderTemplate,
    s3files,
    customerPortal,
    requestCategory,
    interactionType,
    progressStatus,
    crmOpportunityTypes,
    customerSegments,
    lifecycleStage,
    customerGroups,
    checkoffTemplates,
    checkoffTypes,
    orderItemStore,
    orderRentalAssetStore,
    orderAttachmentsStore,
    customerAttachmentsStore,
    paymentAttachmentsStore,
    companyAttachmentsStore,
    orderMessagesStore,
    analytics,
    synchronizer,
    payments,
    masterBank,
    reportTemplates,
    asset_rental,
    assetScheduleStore,
    emailSchedules,
    health,
    assetAttachmentsStore,
    billPaymentEmailSender,
    billPaymentEmailSubjectLine,
    rpaTask,
    rpaTemplate,
    billPaymentTo,
    document_type,
    master_document,
    masterdocAttachmentsStore,
    acitivityTypeDocStore,
    item_type_group,
    masterItemAttachmentsStore,
    languages,
    holiday,
    payment_type,
    payment_purpose,
    user_roster,
    customer_document,
    targets,
    language,
    orderCategoryAttachmentsStore,
    orderTypeAttachmentsStore,
    orderItemTypeAttachmentsStore,
    masterItemImageStore,
    products,
    services,
    requestAttachmentsStore,
    assetTypeAttachmentsStore,
    assetsImageStore,
    rentals,
    aiRecon,
    quickbook,
  },
  state: {
    user: {},
    activity_type_permissions: [],
    rolePermissions: [],
    isAdmin: false,
    isBlacklisted: false,
    token: null,
    environment: null,
    user_customers: [],
    expires: null,
    verified: false,
    logging_out: false,
    SECRET_KEY: SECRET_KEY,
    web_version: null,
    api_version: null,
    web_version_api : null,
    languages : {},
  },
  getters: {
    authenticated: (state) => !!state.token,
    user_permissions: (state) =>
      (state.rolePermissions || []).filter((x) => x.slug).map((x) => x.slug),
    isAdmin: (state) =>
      state.rolePermissions.length > 0 && state.user_customers.length === 0,
    isBlacklisted: (state) => state.user.is_blacklisted,
    userCustomers: (state) => state.user_customers.map((x) => x.customer),
    mediaBaseUrl: (state) => {
      let { web_domain, has_virus_check } = state.environment || {};
      web_domain = web_domain || 'locahost:8080'
      let media_url;
      if (has_virus_check) {
        if (web_domain?.indexOf("localhost") >= 0) {
          web_domain = Vue.prototype.$DEV_URL;
        }
        media_url = `https://${web_domain}/${Vue.prototype.$MediaPrefix}`;
      } else {
        media_url = Vue.prototype.$OMSStorageUrl;
      }
      return media_url;
    },
    web_domain: (state) => {
      let { web_domain } = state.environment || {};
      web_domain = web_domain || 'locahost:8080'
      if (web_domain?.indexOf("localhost") >= 0) {
        web_domain = Vue.prototype.$DEV_URL;
      }
      return web_domain;
    },
    jsreport_storage_domain: (state) =>
      state?.environment?.jsreport_storage_domain,
    baseURL: (state) => state?.environment?.api_server,
    customer_portal_version: (state) => state?.environment?.customer_portal_version,
    is_development: (state) => !!state?.environment?.is_development,
    js_report_lambda_name: (state) => state?.environment?.js_report_lambda_name,
    ams_presigned_api_url: () => process.env.VUE_APP_AMS_PRESIGNED_API_URL,
  },
  mutations: {
    PROFILE_PICTURE(state, payload) {
      state.user.profile_image = payload;
    },
    VERIFY_PASSWORD(state, verified) {
      state.verified = verified;
    },
    STORE_CUSTOMER(state,data){
      state.customer_portal = data;
    },
    STORE_USER(state,data){
      state.customer_portal_user = data;
    },
    AUTHENTICATE(
      state,
      {
        token,
        user,
        rolePermissions,
        activity_type_permissions,
        user_customers,
        isAdmin,
        expires,
      }
    ) {
      state.token = token;
      state.rolePermissions = rolePermissions || [];
      state.user = user;
      state.user_customers = user_customers || [];
      state.isAdmin = isAdmin;
      state.expires = expires;
      state.activity_type_permissions = activity_type_permissions || [];
    },

    UNAUTHENTICATE(state) {
      state.token = null;
      state.rolePermissions = [];
      state.user_customers = [];
      state.user = {};
    },
    SET_ENVIRONMENT(state, environment) {
      console.log("SET_ENVIRONMENT mutation triggered with:", environment);
      state.environment = environment;
      console.log("Updated state.environment:", state.environment);
    },
    SET_LOGGING_OUT(state, x) {
      state.logging_out = !!x;
    },
    SET_WEB_VERSION(state, x) {
      state.web_version = x;
    },
    SET_API_VERSION(state, x) {
      state.api_version = x;
    },
    SET_LANGUAGES(state,languages){
      state.languages = languages;
    },
    SET_WEB_VERSION_API(state, x) {
      state.web_version_api = x;
    },
  },
  actions: {
    async getBaseURL({ commit }) {
      try {
        const { host } = window.location;
        // if(host.includes(':8080')) throw new Error('getBaseURL is localhost', host)
        console.log("getBaseURL host", host);

        const FIVE_MINUTES = 5 * 60 * 1000;
        const current_time = new Date().getTime();
        let last_time = 0;
        try {
          const payload = Vue.prototype.$secureStorage.getItem(
            "ams-servers-key"
          );
          console.log("getBaseURL from storage:", payload);
          if (payload && typeof payload == "object") {
            const { _time, servers } = payload;
            if (Array.isArray(servers) && servers.length > 0) {
              last_time = _time || 0;
              console.log("SET_ENVIRONMENT",servers[0])
              commit("SET_ENVIRONMENT", servers[0]);
                        
            }
          }
        } catch (error) {
          console.log("getBaseURL error", error);
        }

        if (current_time - last_time > FIVE_MINUTES) {
          const resp = await axios.get(this._vm.$OMSServersUrl, {
            params: {
              web_domain: host,
            },
          });
          console.log("getBaseURL from network", resp);
          const payload = { _time: current_time, servers: resp.data };
          console.log("getBaseURL payload", payload);
          Vue.prototype.$secureStorage.setItem("ams-servers-key", payload);
          console.log("SET_ENVIRONMENT",payload.servers[0]);
          commit("SET_ENVIRONMENT", payload.servers[0]);
        }
      } catch (error) {
        console.log("getBaseURL error", error);
        commit("SET_ENVIRONMENT", {
          api_server: "http://localhost:8000/api/v1/",
        });
      }
    },

    getToken({ commit, dispatch }) {
      try {
        const accessToken = Vue.prototype.$secureStorage.getItem("accessToken");
        if (!accessToken) throw new Error("No Token Found");
        const {
          token,
          user,
          rolePermissions,
          activity_type_permissions,
          user_customers,
          expires,
          isAdmin,
        } = JSON.parse(accessToken);

        console.log("activity_type_permissions:", activity_type_permissions);

        axios.defaults.user = user;
        axios.defaults.rolePermissions = rolePermissions;
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        commit("AUTHENTICATE", {
          token,
          user,
          rolePermissions,
          activity_type_permissions,
          user_customers,
          expires,
          isAdmin,
        });
        dispatch("transactionType/fetchOptions", null, { root: true });
      } catch (err) {
        console.log("getToken", err);
        if (!JSON.parse(Vue.prototype.$secureStorage.getItem("accessToken"))) {
          commit("UNAUTHENTICATE");
          Vue.prototype.$secureStorage.clear();
          // router.push("/login");
        }
        // errorHandler(err);
      }
    },

    changePassword({ commit }, data) {
      return auth
        .changePassword(data)
        .then(() => {
          commit("VERIFY_PASSWORD", true);
        })
        .catch((error) => {
          throw error;
        });
    },
    getCustomer({commit},data){
      return auth
      .getCustomer(data)
      .then(
          ({
              data: {
                  success: { data: customer },
              },
          }) => {
            
            commit('STORE_CUSTOMER', customer)
          }
      )
      .catch(err => {
          errorHandler(err)
      })
    },
    getUser({commit},data){
      return auth
      .getUser(data)
      .then(
          ({
              data: {
                  success: { data: user },
              },
          }) => {
            
            commit('STORE_USER', user)
          }
      )
      .catch(err => {
          errorHandler(err)
      })
    },
    updateCustomerPortal({ commit }, data){
      return auth
      .updateCustomerPortal(data)
      .then(() => {
        // commit("VERIFY_PASSWORD", true);
      })
      .catch((error) => {
        throw error;
      });

    },

    checkPassword({ commit, state }, password) {
      console.log("user", state.user);
      const email = state.user.email;
      return auth
        .login(email, password)
        .then((resp) => {
          const { user } = resp.data.success.data;
          commit("VERIFY_PASSWORD", user.email === email);
        })
        .catch((error) => {
          console.log("error", error);
          commit("VERIFY_PASSWORD", false);
        });
    },

    async login({ commit, dispatch }, { email, password }) {
      return await auth
        .login(email, password)
        .then((resp) => {
          localStorage.removeItem("session_expired");
          const {
            token,
            user,
            expires,
            isAdmin,
            permissions: rolePermissions,
            activity_type_permissions,
            customers: user_customers,
          } = resp.data.success.data;
          console.log("activity_type_permissions:", activity_type_permissions);
          //let token = data.success.data.token

          // commit('authenticated', user)
          axios.defaults.user = user;
          axios.defaults.rolePermissions = rolePermissions;
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          const storeToken = JSON.stringify({
            token,
            user,
            expires,
            isAdmin,
            activity_type_permissions,
            rolePermissions,
            user_customers,
          });

          Vue.prototype.$secureStorage.setItem("accessToken", storeToken);

          // localStorage.setItem(
          //     'rolePermissions',
          //     JSON.stringify(rolePermissions)
          // )
          // localStorage.setItem('accessUser', JSON.stringify(user))
          //Define The Users Access Permissions
          // --------------------------------------------------

          commit("AUTHENTICATE", {
            token,
            user,
            activity_type_permissions,
            rolePermissions,
            expires,
            isAdmin,
            user_customers,
          });

          if (user.web_access == 0) {
            commit('UNAUTHENTICATE');
            Vue.prototype.$secureStorage.clear();
            // router.push('/login');
            throw Vue.prototype.$translate('no_web_access');
          }

          dispatch("transactionType/fetchOptions", null, {
            root: true,
          });
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    profilePicture({ commit, state }, payload) {
      const value = { id: state.user.id, profile_image: payload };
      return auth
        .uploadProfilePicture(value)
        .then(() => {
          commit("PROFILE_PICTURE", value.profile_image);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    customerLogin({ commit, dispatch }, { email, password }) {
      return auth
        .customerLogin(email, password)
        .then((resp) => {
          const {
            token,
            user,
            expires,
            isAdmin,
            customers: user_customers,
          } = resp.data.success.data;
          // commit('authenticated', user)
          axios.defaults.user = user;
          axios.defaults.headers.common["Authorization"] = "Bearer " + token;

          const storeToken = JSON.stringify({
            token,
            user,
            expires,
            isAdmin,
            user_customers,
          });

          Vue.prototype.$secureStorage.setItem("accessToken", storeToken);
          commit("AUTHENTICATE", {
            token,
            user,
            expires,
            isAdmin,
            user_customers,
          });

          dispatch("transactionType/fetchOptions", null, {
            root: true,
          });
        })
        .catch((error) => {
          throw error;
        });
    },

    async logout({ commit }) {
      try {
        commit("SET_LOGGING_OUT", true);
        await auth.logout();
        commit("UNAUTHENTICATE");
        // location.reload(true);
      } catch (err) {
        console.error("logout", err);
      } finally {
        axios.defaults.headers.common["Authorization"] = "";
        Vue.prototype.$secureStorage.clear();
        router.push("/login");
        commit("SET_LOGGING_OUT", false);
      }
    },
    async getVersions({ commit }) {
      try {
        const {
          data: {
            success: { data },
          },
        } = await axios.get("auth/version");
        commit("SET_WEB_VERSION", packageJson.version);
        commit("SET_API_VERSION", data);
       
      } catch (err) {
        console.error("logout", err);
        commit("SET_WEB_VERSION", "");
        commit("SET_API_VERSION", "");
       
      }
    },
    // async getVersionsWeb({ commit }) {
    //   try {
    //     const {
    //       data: {
    //         success: { data },
    //       },
    //     } = await axios.get("auth/version/web");
      
    //     commit("SET_WEB_VERSION_API", data);
    //   } catch (err) {
    //     console.error("logout", err);
      
    //     commit("SET_WEB_VERSION_API", "");
    //   }
    // },
    async getVersionsWeb({ commit }) {
      try {
        // Get the host (domain) from the current window location
        const { host } = window.location;
    
        // Log the host to ensure it's being captured correctly
        // console.log("Host:", host);
    
        // Construct the URL with the query parameter for the host
        const url = new URL(this._vm.$OMSServersUrl);
        url.searchParams.append("web_domain", host);
    
        // Make the GET request to the API with the host as a query parameter
        const response = await fetch(url.toString());
    
        // Check if the response is okay (status code in the range 200-299)
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        // Parse the JSON response
        const data = await response.json();
        
        // Log the full response to help with debugging
        // console.log("API Response:", data);
    
        // Safely extract the min_web_version from the first object in the array
        let version = data.length > 0 ? data[0]?.min_web_version : "";
    
        // Commit the version data to the Vuex store
        commit("SET_WEB_VERSION_API", version);
      } catch (err) {
        // Log the error for debugging
        console.error("Error during API call:", err);
    
        // Commit an empty string if the API call fails
        commit("SET_WEB_VERSION_API", "");
      }
    },
    async getLanguage({commit}){
      try {
        const {
          data: {
            success: { data },
          },
        } = await axios.get("lang/translations");
        console.log('data is---------------------',data)
        commit("SET_LANGUAGES", data);
      } catch (err) {
        console.error("error", err);
      
      }
    },
    async setLanguage(_,payload){
      try {
          await axios.post("lang/translations",payload);
          
        
      } catch (err) {
        console.error("logout", err);
      
      }
    }
  },
});
